import { $authHost } from ".";
import {
  GetPriceListResponse,
  GetPriceSectionsResponse,
  GetCartCostResponse,
  CartItem,
} from "@/@types/catalog.types";

export interface GetPriceListParams {
  club_id: string;
  type?: "membership" | "package" | "service";
  service_id?: string;
  section_id?: string;
}

export async function getPriceList(params: GetPriceListParams) {
  const response = await $authHost.request<GetPriceListResponse>({
    url: "/price_list",
    params,
  });
  return response;
}

export interface GetPriceSectionsParams {
  club_id: string;
  view?: string;
}

export async function getPriceSections(params: GetPriceSectionsParams) {
  const response = await $authHost.request<GetPriceSectionsResponse>({
    url: "/price_sections",
    params,
  });
  return response;
}

export interface GetCartCostParams {
  club_id: string;
  cart: CartItem[];
  promocode?: string;
  certificate?: string;
}

export async function getCartCost(params: GetCartCostParams) {
  const cartJson = JSON.stringify({ cart_array: params.cart });
  const response = await $authHost.request<GetCartCostResponse>({
    url: "/cart_cost",
    params: {
      club_id: params.club_id,
      cart: cartJson,
      promocode: params.promocode,
      certificate: params.certificate,
    },
  });
  return response;
}
